module.exports = __webpack_public_path__ + "img/Noctiluca-Process-3-mobile.8fd0443a.png";